import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResult, APiResultError } from '@osos/shared/types';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpUtilsService } from '../services';

@Injectable()
export class HttpResultInterceptor implements HttpInterceptor {
  constructor(private HttpUtilsService: HttpUtilsService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const body: ApiResult = event.body;
          if (this.isSuccessfulResponse(event)) {
            return body?.hasOwnProperty('result')
              ? event.clone({ body: body.result })
              : event;
          }
          if (this.isFailedResponse(event)) {
            throwError(body.error);
          }
        }
        return event;
      }),
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse) {
          return throwError(() => err);
        }

        // Map error
        if (err?.hasOwnProperty('code')) {
          return throwError(() =>
            this.HttpUtilsService.getCorrespondingTranslationKey(
              (err as APiResultError).code
            )
          );
        }

        return throwError(() => err);
      })
    );
  }

  isSuccessfulResponse(res: HttpResponse<any>): boolean {
    return this.isResponseStatusAccepted(res.status) && res.body?.success;
  }

  isFailedResponse(res: HttpResponse<any>): boolean {
    return res?.body?.error && !this.isResponseStatusAccepted(res.status);
  }

  isResponseStatusAccepted(status: number) {
    return status.toString().startsWith('2');
  }
}
